import React from 'react'

import { Typography, useDimensions } from '@telavita-core/react-design-kit'
import { PlanGroupCategoryEnum } from 'settings/_planGroupSettings'
import PopoverMenu from 'components/PopoverMenu'

import { ReactComponent as FilterIcon } from 'static/svg/filter-list.svg'

const ProfessionalsNetwork = ({
  planGroupName,
  planName,
  planGroupCategory,
  patientPlans = [],
  selectedPlanCode,
  onUpdatePlan
}) => {
  const { isMobile } = useDimensions()

  const { PARTICULAR, VITTA } = PlanGroupCategoryEnum

  const isParticular = [PARTICULAR, VITTA].includes(planGroupCategory)

  const showPlanSwitch = patientPlans.length >= 2

  const orderedPatientPlans = patientPlans.sort((a, b) => {
    const aPlanGroupName = a.plan_group.name.toLowerCase()
    const bplanGroupName = b.plan_group.name.toLowerCase()

    if (a.partner_plan_is_particular && !b.partner_plan_is_particular) {
      return 1
    }
    if (!a.partner_plan_is_particular && b.partner_plan_is_particular) {
      return -1
    }
    if (aPlanGroupName < bplanGroupName) {
      return -1
    }
    if (aPlanGroupName > bplanGroupName) {
      return 1
    }
    return 0
  })

  const planSwitchOptions = orderedPatientPlans.map(pPlan => ({
    id: pPlan.partner_plan_code,
    title: pPlan.plan_group.name,
    subTitle: pPlan.partner_plan_name,
    onClick: () => onUpdatePlan(pPlan.partner_plan_code),
  }))


  return (
    <div className='ProfessionalsNetwork'>
      <div className='ProfessionalsNetwork__PlanInfoWrapper'>
        <Typography
          customClassName='ProfessionalsNetwork__Text'
          variant='content3'
        >
          Rede de profissionais:
        </Typography>
        <Typography
          customClassName='ProfessionalsNetwork__Text'
          weight='bold'
          variant='content1'
        >
          {!isParticular && planGroupName} {planName}
        </Typography>
      </div>
      {showPlanSwitch && (
        <div className='ProfessionalsNetwork__PopoverMenuWrapper'>
          <PopoverMenu
            label='VISUALIZAR PROFISSIONAIS:'
            buttonText='TROCAR'
            buttonTextColor={isMobile ? '#898989' : '#fff'}
            customIcon={<FilterIcon />}
            options={planSwitchOptions}
            selectedOption={selectedPlanCode}
            buttonCustomClassName='ProfessionalsNetwork__PopoverMenuWrapper__Button'
          />
        </div>
      )}
    </div>
  )
}

export default ProfessionalsNetwork
